import {
  DrawerBookingDataType,
  DrawerSliceInitial,
} from "@models/services/drawer";
import { CaseReducer, createSlice, PayloadAction } from "@reduxjs/toolkit";

import bookingSlice from "./booking.slice";

const EMPTY_DRAWER_BOOKING_DATA: DrawerBookingDataType = {
  resourceId: "",
  selectedTime: "",
  slot: "",
};

const initialState: DrawerSliceInitial = {
  drawerBookingData: EMPTY_DRAWER_BOOKING_DATA,
  openPercent: 0,
  showBookingDrawer: false,
};

type DrawerSliceReducer<Payload> = CaseReducer<
  DrawerSliceInitial,
  PayloadAction<Payload>
>;

const setDrawerBookingData: DrawerSliceReducer<DrawerBookingDataType> = (
  state,
  action
) => {
  state.drawerBookingData = action.payload;
};

const setShowBookingDrawer: DrawerSliceReducer<boolean> = (state, action) => {
  state.showBookingDrawer = action.payload;
};

const setOpenPercent: DrawerSliceReducer<number> = (state, action) => {
  state.openPercent = action.payload;
};

const removeDrawerBookingState: DrawerSliceReducer<null> = state => {
  state.drawerBookingData = EMPTY_DRAWER_BOOKING_DATA;
  state.showBookingDrawer = false;
};

export const drawerSlice = createSlice({
  extraReducers: builder => {
    builder
      .addCase(bookingSlice.actions.changeSelectedDate, state => {
        state.drawerBookingData = EMPTY_DRAWER_BOOKING_DATA;
        state.showBookingDrawer = false;
      })
      .addCase(bookingSlice.actions.flush, state => {
        state.drawerBookingData = EMPTY_DRAWER_BOOKING_DATA;
        state.showBookingDrawer = false;
      });
  },
  initialState,
  name: "drawer",
  reducers: {
    removeDrawerBookingState,
    setDrawerBookingData,
    setOpenPercent,
    setShowBookingDrawer,
  },
});

export default drawerSlice;
